enum LearningModes {
	questions = "question",
	writing = "writing",
	listening = "listening",
	speaking = "speaking",
	reading = "reading",
	flashcards = "flashcards",
	quiz = "quiz",
}
enum LearningGoals {
	linear = "LINEAR",
	optimized = "OPTIMIZED",
	shuffled = "SHUFFLED",
}

export { LearningModes, LearningGoals };
